import { GeolocationCoords } from '../hooks/useGeolocation';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';
const VIA_CEP_BASE_URL = 'https://viacep.com.br/ws';
const GEOCODING_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

interface ViaCepResponse {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

interface GoogleGeocodingResult {
  status: string;
  results: Array<{
    geometry: {
      location: { lat: number; lng: number };
    };
  }>;
}

async function geocodeAddress(address: string): Promise<GeolocationCoords> {
  const params = new URLSearchParams({
    address,
    key: GOOGLE_MAPS_API_KEY,
    region: 'br',
    language: 'pt-BR',
  });

  const response = await fetch(`${GEOCODING_BASE_URL}?${params.toString()}`);
  if (!response.ok) throw new Error('Falha ao contatar o serviço de localização');

  const data: GoogleGeocodingResult = await response.json();

  if (data.status !== 'OK' || !data.results.length) {
    throw new Error('Endereço não encontrado');
  }

  const { lat, lng } = data.results[0].geometry.location;
  return { latitude: lat, longitude: lng };
}

export async function cepToCoords(rawCep: string): Promise<GeolocationCoords> {
  const cep = rawCep.replace(/\D/g, '');
  if (cep.length !== 8) throw new Error('CEP inválido');

  const response = await fetch(`${VIA_CEP_BASE_URL}/${cep}/json/`);
  if (!response.ok) throw new Error('Falha ao buscar o CEP');

  const data: ViaCepResponse = await response.json();
  if (data.erro) throw new Error('CEP não encontrado');

  const addressParts = [data.logradouro, data.bairro, data.localidade, data.uf, 'Brasil'];
  const address = addressParts.filter(Boolean).join(', ');

  return geocodeAddress(address);
}

export async function cityToCoords(city: string): Promise<GeolocationCoords> {
  if (!city.trim()) throw new Error('Informe uma cidade');
  return geocodeAddress(`${city.trim()}, Brasil`);
}
